import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

const LogoOut = ({ prenom, nom }) => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    setIsLoggingOut(true);
    setTimeout(() => {
      localStorage.removeItem("login2");
      localStorage.removeItem("userId");
      navigate('/');
    }, 1500);
  };

  return (
    <div className="logout-container">
      <style>{`
        .logout-container {
          min-height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }
        .logout-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(15px);
          padding: 40px;
          border-radius: 30px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          text-align: center;
          max-width: 400px;
          animation: fadeIn 0.5s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .avatar-circle {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #f40852, #f46c3e);
          border-radius: 50%;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          box-shadow: 0 10px 20px rgba(244, 8, 82, 0.3);
        }
        .btn-confirm {
          background: #ff4757;
          border: none;
          padding: 12px 30px;
          border-radius: 12px;
          color: white;
          font-weight: bold;
          margin-top: 20px;
          cursor: pointer;
          width: 100%;
        }
        .btn-cancel {
          background: transparent;
          border: 1px solid rgba(255,255,255,0.2);
          color: rgba(255,255,255,0.6);
          padding: 10px;
          margin-top: 10px;
          width: 100%;
          border-radius: 12px;
          cursor: pointer;
        }
      `}</style>

      <div className="logout-card">
        <div className="avatar-circle">
          Bye!
        </div>
        <h3>Au revoir, {prenom} !</h3>
        <p style={{ opacity: 0.7 }}>Voulez-vous vraiment vous déconnecter ?</p>
        
        <button 
          className="btn-confirm" 
          onClick={handleLogout}
          disabled={isLoggingOut}
        >
          {isLoggingOut ? "Déconnexion..." : "Oui, me déconnecter"}
        </button>
        
        {!isLoggingOut && (
          <button className="btn-cancel" onClick={() => navigate(-1)}>
            Annuler
          </button>
        )}
      </div>
    </div>
  );
};

export default LogoOut;